import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ModelInfo from "./modelInfo";
import { userInfoResponse } from "@/models/equip-api-response-objects/userInfoResponse";
import { equipmsalinstance } from "@/services/auth/EquipMsalClient";

export default function Dashboard(props: { user: userInfoResponse }) {
  const [modelPresent, setModelPresent] = useState<string | null>(null);

  useEffect(() => {
    const equipModelId = async () => {
      await Excel.run(async (ctx) => {
        const sheets = ctx.workbook.worksheets;
        sheets.load();
        await ctx.sync();

        const equipSheet = sheets.items.find((sheet) => sheet.name == "EQUIP_MODEL_DATA");
        if (equipSheet == undefined) return;

        equipSheet.names.load();
        await ctx.sync();

        const equipId = equipSheet.names.items.find((name) => name.name == "_eq_company_id");
        if (equipId == undefined) return;

        const range = equipId.getRange();
        range.load("values");
        await ctx.sync();

        const cellValue = range.values[0][0] as string;
        setModelPresent(cellValue);
      });
    };
    equipModelId();
  }, []);

  return (
    <Box p={2}>
      <Typography variant="h6" fontWeight="600">
        Equip Equity Research {equipmsalinstance.GetEnvironment()}
      </Typography>
      <Typography variant="body2" fontWeight="600">
        BASE URL: {equipmsalinstance.GetBaseUrl()}
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Welcome, {props.user?.firstName} {props.user?.lastName}
      </Typography>
      {modelPresent != null && <ModelInfo companyId={modelPresent} />}
    </Box>
  );
}
